import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Page} from '../../../types/enums/page.enum';

export type PageSlice = {
  value: Page;
};

const initialState: PageSlice = {
  value: Page.POLL,
};

const pageSlice = createSlice({
  name: 'pageSlice',
  initialState,
  reducers: {
    set: (state, action: PayloadAction<Page>) => {
      state.value = action.payload;
    },

    reset: () => initialState,
  },
});

export const {set, reset} = pageSlice.actions;
export default pageSlice.reducer;
